export const isValidAccountId = (value: string) => {
  const regex = /^[0-9a-zA-Z]+$/;
  return (value.match(regex) || value === "") && value.length <= 6;
};
